<template>
    <div class="wrapper wrapper-full-page">
        <div class="full-page" data-color="black">
            <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
            <div class="content">
                <div class="container">
                    <div class="col-sm-8 col-md-6 ml-auto mr-auto" style="max-width:370px">
                        <div class="card card-login">
                            <div class="card-header ">
                                <h3 class="header text-center">Войти в систему</h3>
                            </div>
                            <div class="card-body ">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label>Логин</label>
                                        <input type="email" placeholder="Логин..." class="form-control" v-model="user.username" @keyup="logInReset">
                                    </div>
                                    <div class="form-group">
                                        <label>Пароль</label>
                                        <input type="password" placeholder="Пароль..." class="form-control" v-model="user.password" @keyup="logInReset">
                                    </div>
                                    <div class="form-group" v-if="loginError && loginError.length > 0"
                                        style="text-align:center;color:red;margin-top:10px">
                                        {{loginError}}
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer ml-auto mr-auto">
                                <button type="submit" class="btn btn-warning btn-wd" @click="logIn">Войти</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        data() {
            return {
                loading: false,
                user: {
                    username: '',
                    password: ''
                }
            }
        },
        computed: {
            ...mapState(['loginProgress', 'loginError'])
        },
        methods: {
            logIn() {
                this.$store.dispatch('logIn', this.user);
            },
            logInReset() {
                this.$store.dispatch('logInReset');
            }
        }
    }
</script>


<style>
    /* .login-page {
        background-image: url('./assets/images/login_bg.jpg'); 
        background-size: cover; 
        background-position: top center;
    } */
    .login-page {
        background: linear-gradient(#546E7A, #455A64);
    }
</style>
